var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as fetch from 'isomorphic-fetch';
import { BffSource } from 'bernie-core';
var LoyaltySource = /** @class */ (function (_super) {
    __extends(LoyaltySource, _super);
    function LoyaltySource(logger) {
        return _super.call(this, '', logger, {}, {}) || this;
    }
    LoyaltySource.prototype.fetch = function (options) {
        var _a = options.context, id = _a.site.id, tuid = _a.user.tuid, locale = _a.locale;
        var url = this.host + "/gc/memberDetails/" + id + "/" + tuid + "/" + locale;
        return fetch(url, { method: 'GET' }).then(function (res) { return res.json().then(function (response) { return ({ loyalty: response }); }); });
    };
    return LoyaltySource;
}(BffSource));
export { LoyaltySource };
//# sourceMappingURL=loyalty-source.js.map